import styled from "styled-components";
import { ReactComponent as Right } from "../../assets//right.svg";
import Spinner from "../Spinner";

const MBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ justify }) => justify};
  margin: ${({ marginY }) => marginY} 0;
  width: 100%;

  button {
    /* min-width: 100%; */
    /* max-width: 309px; */
    width: 100%;
    height: 54px;
    background: ${({ inverse, theme }) =>
      inverse ? theme.colors.white : theme.colors.primary};

    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 32px;
    padding-right: 9px;
    font-weight: 700;
    font-size: 20px;
    color: ${({ inverse, theme }) =>
      inverse ? theme.colors.primary : theme.colors.white};
    cursor: pointer;

    @media screen and (min-width: 768px) {
      max-width: 309px;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40.68px;
      height: 40.68px;
      background: ${({ inverse, theme }) =>
        inverse ? theme.colors.primary : theme.colors.white};
      border-radius: 50%;

      svg {
        fill: ${({ inverse, theme }) =>
          inverse ? theme.colors.white : theme.colors.primary};
      }
    }
  }
`;

const MainButton = ({
  inverse = false,
  onClick,
  loading = false,
  disabled = false,
  text = "Insert Text",
  justify = "center",
  marginY = "30px",
}) => {
  return (
    <MBtn justify={justify} inverse={inverse} marginY={marginY}>
      <button onClick={onClick} disabled={disabled || loading} type="submit">
        {text}
        <span>{loading ? <Spinner inverse={inverse} /> : <Right />}</span>
      </button>
    </MBtn>
  );
};

export default MainButton;
